import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
// import { CanvasDownloaderService } from '../canvas-downloader/canvas-downloader.service';

@Component({
  selector: 'sume-quadro',
  templateUrl: './quadro.component.html',
  styleUrls: ['./quadro.component.scss'],
})
export class QuadroComponent implements OnInit {
  @ViewChild('modalEdit') modalEdit;
  @ViewChild('dialog') dialogTemplate;

  @ViewChild('screen') screen: ElementRef;

  widthControl = new FormControl(12, [Validators.max(12), Validators.min(1)]);
  jsonControl = new FormControl('');
  div_class = 'col-12';

  @Input() data = {
    title: 'Titulo',
    header: ['#', 'First', 'Last', 'Handle'],
    rows: [
      ['1', 'Mark', 'Otto', '@mdo'],
      ['2', 'Jacob', 'Thornton', '@fat'],
    ],
    footer: ['Sum', '$180', '', ''],
  };

  constructor(
    public dialog: MatDialog, // private canvasDownloader: CanvasDownloaderService,
  ) {}

  ngOnInit(): void {
    this.widthControl.valueChanges.subscribe(res => {
      this.div_class = `col-${res}`;
    });
    this.jsonControl.setValue(JSON.stringify(this.data, undefined, 4));
  }

  updateTable(value) {
    this.data = JSON.parse(value);
  }

  openDialog() {
    const dialogRef = this.dialog.open(this.dialogTemplate);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateTable(this.jsonControl.value);
      }
      console.log(`Dialog result: ${result}`);
    });
  }

  downloadImage(title) {
    // this.canvasDownloader.downloadElement(this.screen, title);
  }
}
